module.exports = __webpack_public_path__ + "static/media/empty.9cabfd27.svg";